import { render, staticRenderFns } from "./2021-07-18.vue?vue&type=template&id=5a53b19a&scoped=true&"
import script from "./2021-07-18.vue?vue&type=script&lang=js&"
export * from "./2021-07-18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53b19a",
  null
  
)

export default component.exports